import { string } from 'yup';

const location = string().max(255, 'Location must be 255 characters or less').required('Please enter a location');

export { location };
